import React from 'react'
import { useAppSelector } from '../../store/hooks/hooks';
import PVTChart from './PVTChart';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ChartSection: React.FC = () => {
	const criteria = useAppSelector(state => state.pvtCalculator.criteria.selected, shallowEqual);
	const chartsData = useAppSelector(state => state.pvtCalculator.chartsData, shallowEqual);
	// const { t } = useTranslation('pvt');
	// const criteriaName = calculator.criteria.selected
	// 	? t(`criteria_options.${calculator.criteria.selected}`)
	// 	: '';

	return <div className="pvt__charts round-corner-container">
		<div className="pvt__chart-card">
			<div className="pvt__chart-card-header">
				{/* <span className="pvt__chart-card-title">{t('chart_vs_p_title')}</span>
				<span className="pvt__chart-card-subtitle">{criteriaName} {t('chart_model_suffix')}</span> */}
			</div>
			<PVTChart criteria={criteria} data={chartsData.map(d => ({ x: d.p, y: d.m }))} />
		</div>
		<div className="pvt__chart-card">
			<div className="pvt__chart-card-header">
				{/* <span className="pvt__chart-card-title">{t('chart_vs_t_title')}</span>
				<span className="pvt__chart-card-subtitle">{t('chart_pressure_isotherms')}</span> */}
			</div>
			<PVTChart criteria={criteria} data={chartsData.map(d => ({ x: d.p, y: d.z }))} />
		</div>
	</div>
}

export default ChartSection